export default __webpack_public_path__ + "1f1bb4446568f601066d1353d5a04eda.webp";